import { render, staticRenderFns } from "./SaldoTable.vue?vue&type=template&id=1875012a&"
import script from "./SaldoTable.vue?vue&type=script&lang=ts&"
export * from "./SaldoTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports